module.exports = "/assets/placeholder.thumbnail.40x40-84975454078557870f765b1913cb4a16.png";